import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";

const DOTS = [
  ["#E398DC", "12%", "22%"], ["#5CC6C0", "84%", "18%"], ["#F7D154", "20%", "78%"], ["#C9A7E8", "78%", "74%"], ["#5CC6C0", "50%", "10%"], ["#F7D154", "90%", "50%"],
];

export default function Loader() {
  const [show, setShow] = useState(() => !sessionStorage.getItem("mps_loaded") && !window.location.pathname.startsWith("/admin"));
  useEffect(() => {
    if (!show) return;
    const t = setTimeout(() => {
      sessionStorage.setItem("mps_loaded", "1");
      setShow(false);
    }, 2600);
    return () => clearTimeout(t);
  }, [show]);
  return (
    <AnimatePresence>
      {show && (
        <motion.div data-testid="loading-screen" className="fixed inset-0 z-[100] flex flex-col items-center justify-center bg-white" exit={{ opacity: 0, scale: 1.04 }} transition={{ duration: 0.5 }}>
          {DOTS.map(([c, l, t], i) => (
            <motion.span key={i} className="absolute rounded-full" style={{ background: c, left: l, top: t, width: 12 + (i % 3) * 5, height: 12 + (i % 3) * 5 }} initial={{ scale: 0 }} animate={{ scale: [0, 1.3, 1] }} transition={{ delay: 1.2 + i * 0.08 }} />
          ))}
          <div className="relative w-[300px] sm:w-[420px] aspect-[900/794]">
            <motion.img src="/l_teacher.png" alt="" className="absolute inset-0 w-full h-full object-contain will-change-transform" decoding="async" initial={{ y: 24, opacity: 0, scale: 0.96 }} animate={{ y: 0, opacity: 1, scale: 1 }} transition={{ type: "spring", stiffness: 120, damping: 16 }} />
            <motion.img src="/l_girl.png" alt="" className="absolute inset-0 w-full h-full object-contain will-change-transform" decoding="async" initial={{ x: -320, opacity: 0 }} animate={{ x: 0, opacity: 1, y: [0, -14, 0, -8, 0] }} transition={{ delay: 0.35, x: { type: "spring", stiffness: 70, damping: 15 }, opacity: { duration: 0.4 }, y: { duration: 1.2, ease: "easeInOut" } }} />
            <motion.img src="/l_boy.png" alt="" className="absolute inset-0 w-full h-full object-contain will-change-transform" decoding="async" initial={{ x: 320, opacity: 0 }} animate={{ x: 0, opacity: 1, y: [0, -12, 0, -7, 0] }} transition={{ delay: 0.5, x: { type: "spring", stiffness: 70, damping: 15 }, opacity: { duration: 0.4 }, y: { duration: 1.2, ease: "easeInOut" } }} />
          </div>
          <motion.p className="font-display text-2xl sm:text-3xl mt-2" initial={{ opacity: 0, y: 10 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 1.4 }}>
            Materiály <span style={{ color: "var(--pink)" }}>pro školky</span>
          </motion.p>
          <motion.p className="font-hand text-lg text-[var(--muted)]" initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ delay: 1.7 }}>
            děti už se sbíhají…
          </motion.p>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
